import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {GlobalsService} from "@services/globals.service";
import {PassengerService} from "@services/passenger.service";
import {FlightSummary, Passenger} from "@app/models";
import {CHECKIN_STATUS, FARES_FAMILY, StatusBag, TypeBagsWeight} from "@app/enums";
import {SeatMap} from "@models/seatMap.model";
/**
  Componente para mostrar un modal con detalles del vuelo.
  Este componente muestra información detallada del vuelo, como el resumen del vuelo,
  los pasajeros seleccionados, la familia de tarifas, el mapa de asientos y la información de equipaje.
**/
@Component({
    selector: 'app-flight-detail-modal',
    templateUrl: './flight-detail-modal.component.html',
    styleUrls: ['./flight-detail-modal.component.scss',],
    standalone: false
})
export class FlightDetailModalComponent implements OnInit {
 /**
    Resumen del vuelo.
  **/
    flightSumary: FlightSummary;

    /**
      Lista de pasajeros seleccionados.
    **/
    passengers: Passenger[];
  
    /**
      Familia de tarifas del vuelo.
    **/
    fareFamily: FARES_FAMILY;
  
    /**
      URL de la imagen asociada a la familia de tarifas.
    **/
    urlImage = null;
  
    /**
      Peso permitido para el equipaje de mano.
    **/
    fareWeight;
  
    /**
      Lista que almacena el conteo de maletas por pasajero.
    **/
    countBags = [];
  
    /**
      Mapa de asientos del vuelo.
    **/
    seatMap;
  
    /**
      Código del segmento del vuelo.
    **/
    segmentCode;
  constructor(
    public modal: NgbActiveModal,
    private _global:GlobalsService,
    private _passengers: PassengerService,
  ) { }

  ngOnInit(): void {
    this.flightSumary = this._global.getReservation().flightSummary
    this.passengers = this._passengers.getPassengerSelection();
    this.fareFamily = this.flightSumary.fareFamily;
    if(this.fareFamily) {
      const base = "assets/images/fares/F_?_w.svg"
      this.urlImage = base.replace('?', this.fareFamily )
    }
    const segments = this.flightSumary.segments._collection;
    this.segmentCode = segments.find(segment => segment.segment.checkinStatus === CHECKIN_STATUS.OPEN)?.segment.segmentCode;
    this.fareWeight = this.passengers[0]?.freeBaggageAllowance?.carryOnWeightKG;
    this.seatMap = this._global.getSeatMapInfo().find(map=> map.segment.segmentCode === this.segmentCode);

    this.prepareInfo();
  }
  /**
    Prepara la información de equipaje y asientos para cada pasajero.
    @return Array<{bags20: number, bags25: number}> - Retorna una lista de objetos con el conteo de maletas y la información del asiento.
  **/
  prepareInfo(): Array<{bags20: number, bags25:  number}> {
    return this.countBags = this.passengers.map(p=>{
      const {seat, type} = this.getSeat(p,this.seatMap, this.segmentCode)
      return {
        bags20: this.getBagsCount(p, "20"),
        bags25: this.getBagsCount(p, "25"),
        seat,
        type,
      }
    })
  }
    /**
    Obtiene el número de maletas de un tipo específico para un pasajero.
    @param passenger Pasajero del cual se obtendrá el conteo de maletas.
    @param type Tipo de maleta ("20" o "25").
    @return number - Retorna el número de maletas del tipo especificado.
  **/
  getBagsCount(passenger: Passenger, type: "25" | "20"): number {
    return (passenger?.bagStack ?? []).filter((b) => b.statusBag === StatusBag.INCLUDE).length;
  }
  /**
    Obtiene el asiento y el tipo de asiento de un pasajero en un segmento específico.
    @param passenger Pasajero del cual se obtendrá la información del asiento.
    @param seatMap Mapa de asientos del vuelo.
    @param segmentCode Código del segmento del vuelo.
    @return any - Retorna un objeto con el código del asiento y el tipo de asiento.
  **/
  getSeat(passenger: Passenger, seatMap: SeatMap = null, segmentCode: string = null): any{
    const seats =  passenger.seats;


    const seat = seats.find(seat => seat.segmentCode === segmentCode).code || null;
    const [type] = seat ? seatMap.seatMap[seat]?.choice?.seatCharacteristics : null;
    return {
      seat,
      type,
    };
  }

  protected readonly FARES_FAMILY = FARES_FAMILY;
  protected readonly TypeBagsWeight = TypeBagsWeight;
}
